import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=17e0b29f&scoped=true"
import script from "./salon.vue?vue&type=script&lang=js"
export * from "./salon.vue?vue&type=script&lang=js"
import style0 from "./salon.vue?vue&type=style&index=0&id=17e0b29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e0b29f",
  null
  
)

export default component.exports